import React from "react"
import { useTranslation } from "react-i18next"

import { TextInput } from "shared/ui/input/text/TextInput"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormFeaturesContext } from "../../contexts/ProductPositionFormFeaturesContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"

export const ProductPositionVariantKeyInput = React.memo(() => {
  const { t } = useTranslation()
  const { isReadonly, isDisabled, formOptions } =
    useProductPositionFormCoreContext()
  const { isLoading } = useProductPositionFormLoadingContext()
  const { formData } = useProductPositionFormFeaturesContext()
  const { isVariantKeyReadonly } = formOptions || {}
  const { configurationKey, dimensioning } = formData?.productPosition || {}

  return (
    <TextInput.Root
      name="productPosition.variantKey"
      data-testid="product-position-form__variant-key"
      className="product-position-form__variant-key"
      label={t("Product.VariantKey")}
      readonly={
        isReadonly ||
        isVariantKeyReadonly ||
        !!configurationKey ||
        !!dimensioning
      }
      loading={isLoading}
      disabled={isDisabled}
    >
      <TextInput.Label />
      <TextInput.Focus>
        <TextInput.Input
          type="text"
          data-testid="product-position-form__variant-key-input"
          className="product-position-form__variant-key-input"
        />
      </TextInput.Focus>
      <TextInput.Readonly />
      <TextInput.ErrorMessage />
    </TextInput.Root>
  )
})
